export default {
  bind(el, binding, vnode) {
    const showRuler = !vnode.context.$store.state.states.showRuler
    const zoom = vnode.context.$store.state.states.zoomActual
    binding.value.el = el
    binding.value.headHeight = parseInt((showRuler ? 74 : 50) / zoom)
    binding.value.handler = handle(binding.value)
    binding.value.zoom = zoom
    if (binding.value.positionType === "sticky") {
      addSticky(binding.value.handler, binding.value)
    }
  },
  update(el, binding, vnode) {
    const showRuler = !vnode.context.$store.state.states.showRuler
    const zoom = vnode.context.$store.state.states.zoomActual
    binding.oldValue.headHeight = parseInt((showRuler ? 74 : 50) / zoom)
    if (binding.oldValue.positionType !== binding.value.positionType && binding.value.positionType === "sticky") {
      addSticky(binding.oldValue.handler, binding.value)
    }
    if (binding.oldValue.positionType !== binding.value.positionType && binding.oldValue.positionType === "sticky") {
      removeSticky(binding.oldValue.handler, binding.value)
    }
    binding.oldValue.positionType = binding.value.positionType
    binding.oldValue.stickyTop = binding.value.stickyTop
    binding.value = binding.oldValue
  },
  unbind(el, binding) {
    removeSticky(binding.value.handler, binding.value)
    binding.value = null
  }
}

const addSticky = (handler, binding) => {
  setTimeout(() => {
    const scrollWrap = document.querySelector("#pageScollbar .el-scrollbar__wrap")
    binding.scrollWrap = scrollWrap
    scrollWrap.addEventListener("scroll", handler)
  }, 200)
}

const removeSticky = (handler, binding) => {
  if(binding.scrollWrap) {
    binding.scrollWrap.removeEventListener("scroll", handler)
    binding.scrollWrap = null
  }
}

// 核心就是根据父元素位置，动态调整距离，达到吸顶效果
const handle = data => {
  return () => {
    const { el, headHeight, stickyTop = 0, zoom = 1 } = data
    const topDistance = el.parentNode.getBoundingClientRect().top || 0
    el.style.position = "relative"
    if ((topDistance - stickyTop) / zoom >= headHeight) {
      el.style.top = 0
    } else {
      el.style.top = `${headHeight + (stickyTop - topDistance) / zoom}px`
    }
  }
}
